import { render, staticRenderFns } from "./VatCheckGuardV1.vue?vue&type=template&id=5f715080&scoped=true"
import script from "./VatCheckGuardV1.vue?vue&type=script&lang=js"
export * from "./VatCheckGuardV1.vue?vue&type=script&lang=js"
import style0 from "./VatCheckGuardV1.vue?vue&type=style&index=0&id=5f715080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f715080",
  null
  
)

export default component.exports